// 簡化的 Firebase 配置，用於解決初始化問題
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";

// Firebase 配置 - 使用環境變量
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'auth.checkplay.me',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// 初始化 Firebase
let app;
let auth;
let db;
let storage;

try {
  console.log('🔧 開始初始化 Firebase...');
  console.log('🔧 Firebase 配置:', {
    apiKey: firebaseConfig.apiKey ? '✅ 已設定' : '❌ 未設定',
    authDomain: firebaseConfig.authDomain ? '✅ 已設定' : '❌ 未設定',
    projectId: firebaseConfig.projectId ? '✅ 已設定' : '❌ 未設定',
    storageBucket: firebaseConfig.storageBucket ? '✅ 已設定' : '❌ 未設定',
    messagingSenderId: firebaseConfig.messagingSenderId ? '✅ 已設定' : '❌ 未設定',
    appId: firebaseConfig.appId ? '✅ 已設定' : '❌ 未設定'
  });
  
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
    console.log('✅ Firebase 應用初始化成功');
  } else {
    app = getApp();
    console.log('✅ 使用現有的 Firebase 應用');
  }

  // 初始化 Firebase 服務
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  
  console.log('✅ Firebase 服務初始化完成');
  
  // 標記 Firebase 已載入
  if (typeof window !== 'undefined') {
    (window as any).firebaseLoaded = true;
    
    // 通知 services/firebase.ts 設置服務
    if ((window as any).setFirebaseServices) {
      (window as any).setFirebaseServices({ auth, db, storage });
    }
  }
  
} catch (error) {
  console.error('❌ Firebase 初始化失敗:', error);
  
  // 即使初始化失敗，也要設置標記
  if (typeof window !== 'undefined') {
    (window as any).firebaseLoaded = false;
  }
}

// 設定 Google 和 Facebook 登入提供者
const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');
// 🔧 修復：強制顯示帳號選擇畫面，避免自動登入
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope('email');

// 導出 Firebase 服務
export { auth, db, storage, app };
export { googleProvider, facebookProvider };

// 導出等待函數（優化版 - 減少等待時間）
export const waitForFirebase = (): Promise<void> => {
  return new Promise((resolve) => {
    if (typeof window !== 'undefined' && (window as any).firebaseLoaded) {
      resolve();
    } else {
      let checkInterval: NodeJS.Timeout;
      
      // 2秒後超時（從 5秒 優化為 2秒）
      const timeout = setTimeout(() => {
        clearInterval(checkInterval);
        console.warn('⚠️ Firebase 初始化超時，繼續執行');
        resolve();
      }, 2000);
      
      // 等待 Firebase 載入（檢查頻率從 100ms 優化為 50ms）
      checkInterval = setInterval(() => {
        if (typeof window !== 'undefined' && (window as any).firebaseLoaded) {
          clearInterval(checkInterval);
          clearTimeout(timeout);
          resolve();
        }
      }, 50);
    }
  });
};
